import React from "react";
import styles from "./TableLayoutV2.module.scss";
import { DownloadOutlined, PlusCircleOutlined } from "@ant-design/icons";
import Button from "antd/lib/button/button";
import { ActionOptions, Checkboxes } from "../../utils/Constants";
import { Tooltip } from "antd";
import Checkbox from "antd/lib/checkbox";
import FormItemLabel from "antd/lib/form/FormItemLabel";
import HistoryModal from '../ModalWindows/ModalWindowWrappers/HistoryModal';
import { EntityType } from '../../integrated-client';
import { ISelectedRowsObject } from './FiltersTableLayoutsWrapperV2';

export interface TableHeaderProps {
  totalItems?: number;
  resultsText?: string;
  showResultsCount?: boolean;
  actionOptionsToRender?: Array<ActionOptions>;
  handleActionOptionClick: (actionOption: ActionOptions) => void;
  optionsAreActive: boolean;
  disabledButton?: boolean;
  addButtonName?: string;
  handleAddRuleButtonClick: () => void;
  allActionOptions?: Array<ActionOptions>;
  itemsSelected?: number;
  disabled?: boolean;
  checkcheckbox: (id: string) => any;
  checkboxActions: (id: string) => void;
  supplierSelected?: boolean;
  filtersBrandAndMarketSelected?: boolean;
  ifSubrule?: boolean;
  showHistoryModal?: boolean;
  setShowHistoryModal?: (val: boolean) => void;
  handleRowSelect: (selectedRowKeys: any[], selectedRows: any[]) => void;
  selectedRowsObject: ISelectedRowsObject;
  onExport?: () => void;
  showAddButton?: boolean;
  addControl?: React.ReactNode;
  actionLabels?: Partial<Record<ActionOptions, string>>;
}

const TableHeader: React.FC<TableHeaderProps> = (props) => {
  const {
    totalItems,
    resultsText,
    showResultsCount = true,
    actionOptionsToRender,
    handleAddRuleButtonClick,
    handleActionOptionClick,
    optionsAreActive,
    addButtonName = "Add Rule",
    allActionOptions,
    disabledButton,
    itemsSelected,
    disabled,
    checkcheckbox,
    checkboxActions,
    supplierSelected,
    filtersBrandAndMarketSelected,
    ifSubrule,
    showHistoryModal,
    setShowHistoryModal,
    handleRowSelect,
    selectedRowsObject,
    onExport,
    showAddButton = true,
    addControl,
    actionLabels,
  } = props;

  const tooltipText = "One or more Brands & Markets do not have Full Control access. To make changes, please select one Brand & Market.";

  return (
    <>
      {supplierSelected || filtersBrandAndMarketSelected ? 
        <div className={styles.selectAllcheckboxContainer}>
          <Tooltip
                className={styles.checkboxTooltip}
                placement="topLeft"
                title={"Select Current Page Records"}
          >
          <Checkbox
            id={Checkboxes.SelectCurrentPage}
            disabled={disabled}
            className={styles.customCheckbox}
            checked={checkcheckbox(Checkboxes.SelectCurrentPage)}
            onChange={() => checkboxActions(Checkboxes.SelectCurrentPage)}
          />
          <FormItemLabel label={"Select Current Page"} prefixCls={""} />
          </Tooltip>
          <Tooltip
                className={styles.checkboxTooltip}
                placement="topLeft"
                title={"Select all records of all pages"}
          >
          <Checkbox
            id={Checkboxes.SelectAllPages}
            disabled={disabled}
            className={styles.customCheckbox}
            checked={checkcheckbox(Checkboxes.SelectAllPages)}
            onChange={() => checkboxActions(Checkboxes.SelectAllPages)}
          />
          <FormItemLabel label={"Select All Pages"} prefixCls={""} />
          </Tooltip>
        </div>
        : ""
      }
      <div className={styles.customTableHeader}>
      <div className={styles.customTableHeaderResults} role="status">
        {showResultsCount && (resultsText ? resultsText : itemsSelected !== 0 ? `${itemsSelected} rule${Number(itemsSelected) > 1 ? "s" : ""} selected out of ${totalItems} results` : `${totalItems} results found`)}
        {onExport && (
          <Tooltip placement="top" title="Export to CSV">
            <Button type="link" icon={<DownloadOutlined />} onClick={onExport} style={{ marginLeft: 8, padding: 0 }} />
          </Tooltip>
        )}
      </div>
      <div className={styles.customTableHeaderActionWrapper}>
          {allActionOptions  &&
            allActionOptions.map((actionOption: ActionOptions) => {
              // Requirement 3: BulkUpdate only visible when multiple rows selected
              if (actionOption === ActionOptions.BulkUpdate && Number(itemsSelected) <= 1) {
                return null;
              }

              return actionOptionsToRender!.length <= 2 ?
                <Tooltip
                  key={actionOption}
                  placement="topLeft"
                  title={(!optionsAreActive || (actionOption === actionOptionsToRender![0] || actionOption === actionOptionsToRender![1])) == true ? "" : tooltipText}
                >
                  <Button
                    type="link"
                    className={styles.customTableHeaderActionBtn}
                    disabled={!optionsAreActive || !(actionOption === actionOptionsToRender![0] || actionOption === actionOptionsToRender![1])}
                    onClick={() =>
                      optionsAreActive && handleActionOptionClick(actionOption)
                    }
                  >
                    {actionLabels?.[actionOption] || actionOption}
                  </Button>
                </Tooltip>
                : <Button
                  key={actionOption}
                  type="link"
                  className={styles.customTableHeaderActionBtn}
                  disabled={!optionsAreActive || (ifSubrule && Number(itemsSelected) > 1 && actionOption === ActionOptions.Copy)}
                  onClick={() =>
                    optionsAreActive && handleActionOptionClick(actionOption)
                  }
                >
                  {actionLabels?.[actionOption] || actionOption}
                </Button>
            })}
      </div>
      {showAddButton && (addControl || (
        <Button
          type="primary"
          disabled={disabledButton}
          className={styles.customTableHeaderAddBtn}
          onClick={() => handleAddRuleButtonClick()}
        >
          <PlusCircleOutlined className={styles.addBtnIcon} />
          {addButtonName}
        </Button>
      ))}
      </div>
      {showHistoryModal && setShowHistoryModal && (
        <HistoryModal
          showHistoryModal={showHistoryModal}
          setShowHistoryModal={setShowHistoryModal}
          actionType={ActionOptions.History}
          type={EntityType.SearchRuleUpdate}
          id={selectedRowsObject.selectedRows[0]?.id as string}
          handleRowSelect={handleRowSelect}
        />
      )}
    </>
  );
};

export default TableHeader;
